// import { useEffect, useState } from "react";
// import { Connection, PublicKey } from "@solana/web3.js";

// // Replace with your QuickNode RPC Endpoint (Mainnet)
// const QUICKNODE_RPC_URL =
//   "https://sly-twilight-dinghy.solana-mainnet.quiknode.pro/81b660f04a3d29b41ac2531a9e10350258b0a4b0/";

// function ContractBalance({ contractAddress }) {
//   const [balance, setBalance] = useState(null);
//   const [usdValue, setUsdValue] = useState(null);

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!contractAddress) return;

//     // Use QuickNode RPC endpoint
//     const connection = new Connection(QUICKNODE_RPC_URL, "confirmed");
//     const pubkey = new PublicKey(contractAddress);

//     const fetchBalance = async () => {
//       try {
//         setLoading(true);

//         const lamports = await connection.getBalance(pubkey);
//         const solBalance = lamports / 1e9; // convert lamports → SOL (no rounding)

//         setBalance(solBalance);

//         // --- Fetch SOL price in USD ---
//         const priceRes = await fetch(
//           "https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd"
//         );
//         const priceData = await priceRes.json();
//         const solUsdPrice = priceData.solana.usd;

//         // Calculate USD value
//         setUsdValue(solBalance * solUsdPrice);
//       } catch (err) {
//         console.error("Error fetching contract balance:", err);
//         setBalance(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBalance();

//     // Re-check every 10 seconds
//     // const interval = setInterval(fetchBalance, 30000);
//     // return () => clearInterval(interval);
//   }, [contractAddress]);

//   if (loading) return <div>Loading contract balance...</div>;
//   if (balance === null) return <div>Error fetching balance</div>;

//   return (
//     <>
//       <div>Contract Balance: {balance} SOL</div>
//       <div>
//         USD Value: $
//         {usdValue?.toLocaleString(undefined, {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         })}
//       </div>
//     </>
//   );
// }

// export default ContractBalance;


import { useEffect, useState } from "react";
import { Connection, PublicKey } from "@solana/web3.js";

const QUICKNODE_RPC_URL = "https://sparkling-fragrant-sailboat.solana-mainnet.quiknode.pro/f6cbd527f9394680d0976261ba666bd0a298b298/";
// const QUICKNODE_RPC_URL = "https://api.mainnet-beta.solana.com";

function ContractBalance({ contractAddress }) {
  const [balance, setBalance] = useState(null);
  const [usdValue, setUsdValue] = useState(null);
  const [solPrice, setSolPrice] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch SOL price once
  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const res = await fetch(
          "https://sparkling-fragrant-sailboat.solana-mainnet.quiknode.pro/f6cbd527f9394680d0976261ba666bd0a298b298/"
        );
        const data = await res.json();
        setSolPrice(data.solana.usd);
      } catch (err) {
        console.error("Price fetch error:", err);
      }
    };

    fetchPrice();
  }, []);

  useEffect(() => {
    if (!contractAddress) return;

    const fetchBalance = async () => {
      try {
        setLoading(true);

        let pubkey;
        try {
          pubkey = new PublicKey(contractAddress);
        } catch {
          throw new Error("Invalid public key");
        }

        const connection = new Connection(QUICKNODE_RPC_URL, "confirmed");

        const lamports = await connection.getBalance(pubkey);
        const solBalance = lamports / 1e9;

        setBalance(solBalance);

        if (solPrice) {
          setUsdValue(solBalance * solPrice);
        }
      } catch (err) {
        console.error("Error fetching contract balance:", err);
        setBalance(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBalance();
  }, [contractAddress, solPrice]);

  if (loading) return <div>Loading contract balance...</div>;
  if (balance === null) return <div>Error fetching balance</div>;

  return (
    <>
      <div>Contract Balance: {balance.toFixed(4)} SOL</div>
      <div>
        USD Value: $
        {usdValue?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
    </>
  );
}

export default ContractBalance;